function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0.600006H46V37.4H0V0.600006ZM2.3 25.3252V35.1H27.72L14.6794 16.0407L2.3 25.3252ZM2.3 22.4502L15.2211 12.7594L30.5068 35.1H43.7V2.90001H2.3V22.4502ZM27.6 17.85C27.6 21.0256 30.1744 23.6 33.35 23.6C36.5256 23.6 39.1 21.0256 39.1 17.85C39.1 14.6744 36.5256 12.1 33.35 12.1C30.1744 12.1 27.6 14.6744 27.6 17.85ZM33.35 21.3C35.2554 21.3 36.8 19.7554 36.8 17.85C36.8 15.9446 35.2554 14.4 33.35 14.4C31.4446 14.4 29.9 15.9446 29.9 17.85C29.9 19.7554 31.4446 21.3 33.35 21.3Z",
  fill: "#CCCCCC"
});

function SvgPlaceholderImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage);
export default __webpack_public_path__ + "static/media/placeholder-image.03a97889.svg";
export { ForwardRef as ReactComponent };